import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TextButton } from 'components/TextButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { CURRENT_PATH, ROUTE_POLICY_INFO_AND_RATES } from 'utils/constants';

const useStyles = makeStyles((theme: any) => ({
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
}));

export const EditPremiumLineLink = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <Box onClick={() => {
      localStorage.setItem(CURRENT_PATH, JSON.stringify({ view: ROUTE_POLICY_INFO_AND_RATES }));
    }}
    >
      <Link
        to={location.pathname.replace('charges', 'policy-info-and-rates')}
        className={classes.link}
      >
        <TextButton text={t('orders:editPremiumLineButton')} icon="edit" />
      </Link>
    </Box>
  );
};
